/* eslint-disable react/prop-types */
import React from 'react';
import { hexToHsva, color as handleColor } from './ColorUtils';

const Swatch = React.forwardRef((props, ref) => {
  const {
    prefixCls = 'saws-color-swatch',
    className,
    color,
    colors = [],
    style,
    rectProps = {},
    onChange,
    addonAfter,
    addonBefore,
    rectRender,
    ...other
  } = props;

  const rectStyle = {
    background: 'rgb(144, 19, 254)',
    height: 15,
    width: 15,
    marginRight: 5,
    marginBottom: 5,
    cursor: 'pointer',
    position: 'relative',
    outline: 'none',
    borderRadius: 2,
    ...rectProps.style,
  };

  const handleClick = (hex, evn) => {
    onChange && onChange(hexToHsva(hex), handleColor(hexToHsva(hex)), evn);
  };

  return (
    <div
      ref={ref}
      {...other}
      className={[prefixCls, className || ''].filter(Boolean).join(' ')}
      style={{
        display: 'flex',
        flexWrap: 'wrap',
        position: 'relative',
        ...style,
      }}
    >
      {addonBefore && React.isValidElement(addonBefore) && addonBefore}
      {colors &&
        Array.isArray(colors) &&
        colors.map((item, idx) => {
          let title = '';
          let background = '';
          if (typeof item === 'string') {
            title = item;
            background = item;
          }
          if (typeof item === 'object' && item.color) {
            title = item.title || item.color;
            background = item.color;
          }
          const checked = color && color.toLocaleLowerCase() === background.toLocaleLowerCase();
          if (rectRender) {
            return rectRender({
              key: idx,
              title,
              color: background,
              checked: !!checked,
              style: { ...rectStyle, background },
              onClick: (evn) => handleClick(background, evn),
            });
          }
          const child =
            rectProps.children && React.isValidElement(rectProps.children)
              ? React.cloneElement(rectProps.children, {
                  color: background,
                  checked,
                })
              : null;
          return (
            <div
              tabIndex={0}
              key={idx}
              title={title}
              onClick={(evn) => handleClick(background, evn)}
              {...rectProps}
              // eslint-disable-next-line react/no-children-prop
              children={child}
              style={{ ...rectStyle, background }}
            />
          );
        })}
      {addonAfter && React.isValidElement(addonAfter) && addonAfter}
    </div>
  );
});

Swatch.displayName = 'Swatch';

export default Swatch;
